"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setRequestInterceptor = exports.httpRequest = exports.httpDelete = exports.httpPut = exports.httpPost = exports.httpGet = void 0;
/* eslint-disable prefer-promise-reject-errors */
var axios_1 = __importDefault(require("axios"));
var utils_1 = require("./utils");
var constants_1 = require("./constants");
var http = axios_1.default.create({
    timeout: 5000,
    withCredentials: true,
});
http.interceptors.request.use(function (config) {
    var customHeaders = {};
    if (!config.noRequestId) {
        customHeaders['request-id'] = utils_1.getRequestId();
    }
    if (config.appName) {
        customHeaders.caller = config.appName.toUpperCase();
    }
    config.headers = __assign(__assign({}, config.headers), customHeaders);
    if (config.postType === 'form') {
        config.headers['content-type'] = 'application/x-www-form-urlencoded';
        config.transformRequest = [function (data) { return utils_1.joinParams(data); }];
    }
    return config;
});
function onResponse(res) {
    var data = res.data;
    if (+(data === null || data === void 0 ? void 0 : data.code) === 200) {
        return Promise.resolve(data.data);
    }
    if (data.code === undefined) {
        return Promise.resolve(data);
    }
    return Promise.reject(data);
}
function onError(error) {
    // 此处一般是网络错误
    var message = error.message;
    return Promise.reject({
        code: constants_1.NETWORK_ERROR,
        data: error.response,
        message: message,
    });
}
function httpGet(url, config) {
    return http.get(url, config).catch(onError).then(onResponse);
}
exports.httpGet = httpGet;
function httpPost(url, data, config) {
    return http.post(url, data, config).catch(onError).then(onResponse);
}
exports.httpPost = httpPost;
function httpPut(url, data, config) {
    return http.put(url, data, config).catch(onError).then(onResponse);
}
exports.httpPut = httpPut;
function httpDelete(url, config) {
    return http.delete(url, config).catch(onError).then(onResponse);
}
exports.httpDelete = httpDelete;
function httpRequest(config) {
    return http.request(config).catch(onError).then(onResponse);
}
exports.httpRequest = httpRequest;
function setRequestInterceptor(func) {
    http.interceptors.request.use(func);
}
exports.setRequestInterceptor = setRequestInterceptor;
//# sourceMappingURL=standard.js.map